module.exports = __webpack_public_path__ + "img/136A9440-1280.f9aee6ea.jpg";